"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockBrand = void 0;
function mockBrand(overrides = {}) {
    return {
        banner_image: 'http://example.com/banner.jpg',
        description: 'Mock description',
        display_name: 'Mock Brand',
        display_order: null,
        featured: false,
        hidden: false,
        image: 'http://example.com/img.jpg',
        meta_description: null,
        meta_title: null,
        name: 'mock_brand',
        no_products: false,
        page_heading: null,
        page_subheading: null,
        promo_banner: null,
        url_slug: 'mock_brand',
        user_favorite: false,
        user_event_notifications: {
            product_added: false,
            frequency: 'weekly',
        },
        ...overrides,
    };
}
exports.mockBrand = mockBrand;
